<template>
    <div :class="{ rowshow: !isRow, 'form-item': !!label }">
        <div class="form-label">{{ label }}</div>
        <div class="form-ctx" :class="{'align-right': alignRight}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
/**
 * 切换 一行/两行 展示表单项
 */
export default {
    name: 'apolloH5FormItem',
    componentName: 'apolloH5FormItem',
    props: {
        label: {
            type: String,
            default: ''
        },
        // 是否一行
        isRow: {
            type: Boolean,
            default: true
        },
        // 验证key
        validateKey: {
            type: String,
            default: ''
        },
        alignRight: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/variable.less';
.form-item {
    display: flex;
    flex: 1;
    max-width: 100%;
    border-bottom: 1 * @layout375 solid #f0f1f2;
    font-size: 16 * @layout375;
    color: #363c54;
    &.rowshow {
        display: flex;
        border-bottom: 1px solid #f0f1f2;
        flex-direction: column;
        .form-label {
            line-height: initial;
            font-size: 12 * @layout375;
            color: #9b9da9;
            margin-top: 12 * @layout375;
            min-width: 0;
        }
        .form-ctx {
            border-bottom: 0;
            flex: auto;
        }
    }
    .form-label {
        font-size: 16 * @layout375;
        color: #363c54;
        line-height: 60 * @layout375;
        margin-right: 10 * @layout375;
        white-space: nowrap;
        min-width: 65 * @layout375;
    }
    .form-ctx {
        min-height: 60 * @layout375;
        line-height: 60 * @layout375;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        position: relative;
        &.align-right {
            justify-content: flex-end;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/testdrive_components/layout/create-form/form-item.vue